export const METHOD_NAV_HISTORY_LIMIT = 15;

export function methodHistoryEntry(entry) {
    if (!entry?.id)
        return null;
    return {
        id: entry.id,
        type: entry.type || null,
        name: entry.name || '',
        parentID: entry.parentID || null,
    };
}

export function methodHistoryTop(stack) {
    const cur = stack || [];
    return cur.length ? cur[cur.length - 1] : null;
}

/** Newest last. Ignores empty / same-as-top. Caps at limit (drops oldest). */
export function pushMethodHistory(stack, entry, limit = METHOD_NAV_HISTORY_LIMIT) {
    const item = methodHistoryEntry(entry);
    const next = (stack || []).slice();
    if (!item)
        return next;
    const top = next[next.length - 1];
    if (top?.id === item.id)
        return next;
    next.push(item);
    const cap = limit > 0 ? limit : METHOD_NAV_HISTORY_LIMIT;
    if (next.length > cap)
        next.splice(0, next.length - cap);
    return next;
}

export function popMethodHistory(stack) {
    const next = (stack || []).slice();
    const entry = next.pop() || null;
    return { next: entry, stack: next };
}

/**
 * Debug step-out: drop the history entry for the method we are returning to
 * (pushed when we stepped into the callee). No-op if top does not match.
 */
export function popMethodHistoryIfTopMatches(stack, id) {
    const cur = stack || [];
    if (!id || !cur.length || cur[cur.length - 1]?.id !== id)
        return cur.slice();
    return cur.slice(0, -1);
}

/** Jump to stored index (0 = oldest). Drops that entry and everything after it. */
export function jumpMethodHistory(stack, index) {
    const cur = stack || [];
    if (index < 0 || index >= cur.length)
        return { next: null, stack: cur.slice() };
    return { next: cur[index], stack: cur.slice(0, index) };
}

/** Back: pop history, park current on forward. */
export function navigateMethodHistoryBack(history, forward, current, limit = METHOD_NAV_HISTORY_LIMIT) {
    const popped = popMethodHistory(history);
    if (!popped.next)
        return { history: popped.stack, forward: forward || [], next: null };
    return {
        history: popped.stack,
        forward: pushMethodHistory(forward, current, limit),
        next: popped.next,
    };
}

/** Forward: pop forward, park current on history. */
export function navigateMethodHistoryForward(history, forward, current, limit = METHOD_NAV_HISTORY_LIMIT) {
    const popped = popMethodHistory(forward);
    if (!popped.next)
        return { history: history || [], forward: popped.stack, next: null };
    return {
        history: pushMethodHistory(history, current, limit),
        forward: popped.stack,
        next: popped.next,
    };
}

export function renameMethodHistory(stack, id, name) {
    if (!id || name == null)
        return (stack || []).slice();
    return (stack || []).map((entry) => (entry.id === id ? { ...entry, name } : entry));
}
